import { createContext, useContext } from "react";

interface ColorModeContextType {
  colorMode: boolean;
}

export const ColorModeContext = createContext<ColorModeContextType | undefined>(undefined);


export const useColorMode = () => {
  const context = useContext(ColorModeContext);
  if (!context) {
    throw new Error("useColorMode must be used within a ColorModeProvider");
  }
  return context;
};